import Vue from 'vue'
import {
    ConfigurationSampleProcessRequest,
    IContentSampleProcessesGrid
} from '@/modules/configurationModule/detail/samples/processesTypes/SampleProcesses.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    ConfigurationSampleProcessPatchInBatchRequest
} from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/services/configuration-sample-process/configuration-sample-process.dto'

class SampleProcessesConfigurationServices extends Vue {
    async paginator(filterModel: any, params: any): Promise<IResponseAgGrid<IContentSampleProcessesGrid>> {
        const response = await this.axios.put(`/configuration/sampleProcesses`, filterModel, { params })
        return response.data
    }
    async patchSampleProcessesBatch(request: ConfigurationSampleProcessPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch(`/configuration/sampleProcesses/batch`, request)
        return response.data
    }
    async createSampleProcesses(request: ConfigurationSampleProcessRequest): Promise<IContentSampleProcessesGrid> {
        const response = await this.axios.post(`/configuration/sampleProcesses`, request)
        return response.data
    }
    async deleteSampleProcessesBatch(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete(`/configuration/sampleProcesses/batch`, { data: request })
        return response.data
    }
}

export const sampleProcessesConfigurationServices = new SampleProcessesConfigurationServices()
